import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const ContactForm: React.FC = () => {
  return <section id="contact" className="w-full bg-gradient-to-r from-[#007AFF] to-[#1B2B44] py-20 md:py-32 relative overflow-hidden" data-id="element-135">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-136">
        {/* Header */}
        <div className="mb-16 max-w-3xl" data-id="element-137">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-138">
            Klaar voor de volgende stap in online groei?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-white/90 text-lg" data-id="element-139">
            Plan een vrijblijvend gesprek! We bekijken samen welke aanpak past
            bij jouw bedrijf en groeifase.
          </motion.p>
        </div>

        {/* Card Container */}
        <div className="relative" data-id="element-140">
          {/* Mascot */}
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute bottom-full right-4 md:right-12 -mb-20 z-20 hidden md:block" data-id="element-141"></motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-3xl overflow-hidden flex flex-col lg:flex-row shadow-2xl relative z-10" data-id="element-142">
            {/* Left Column */}
            <div className="bg-[#EBF3FF] p-8 md:p-12 lg:w-5/12 flex flex-col" data-id="element-143">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hNQXPwX8APxFUETyhYjjKE/Mogelijk_voor_website_%2837%29.jpg" alt="Rocco" className="w-full aspect-[4/5] object-cover rounded-2xl mb-8 shadow-sm border border-white/50" data-id="element-144" />
              <h3 className="text-4xl font-bold text-[#111827] mb-4" data-id="element-145">
                Geïnteresseerd?
              </h3>
              <p className="text-[#4B5563] mb-8 leading-relaxed" data-id="element-146">
                Vul het formulier in en we nemen snel contact met je op om je
                project te bespreken.
              </p>

              <div className="space-y-4 mb-12" data-id="element-147">
                <div className="flex items-center gap-4" data-id="element-148">
                  <div className="w-10 h-10 rounded-full bg-[#007AFF] flex items-center justify-center flex-shrink-0" data-id="element-149">
                    <MailIcon className="w-5 h-5 text-white" data-id="element-150" />
                  </div>
                  <a href="mailto:info@noorddigital.nl" className="text-[#111827] font-medium hover:text-[#007AFF] transition-colors" data-id="element-151">
                    info@noorddigital.nl
                  </a>
                </div>
                <div className="flex items-center gap-4" data-id="element-152">
                  <div className="w-10 h-10 rounded-full bg-[#007AFF] flex items-center justify-center flex-shrink-0" data-id="element-153">
                    <PhoneIcon className="w-5 h-5 text-white" data-id="element-154" />
                  </div>
                  <a href="tel:+31653689686" className="text-[#111827] font-medium hover:text-[#007AFF] transition-colors" data-id="element-155">
                    +31 6 53689686
                  </a>
                </div>
              </div>

              <p className="text-[10px] text-[#6B7280] mt-auto leading-tight" data-id="element-156">
                Uw gegevens zijn bij ons veilig en worden uitsluitend gebruikt
                om u te helpen naar aanleiding van dit formulier
              </p>
            </div>

            {/* Right Column (Form) */}
            <div className="bg-white p-8 md:p-12 lg:w-7/12 relative" data-id="element-157">
              {/* Dots */}
              <div className="absolute top-8 right-8 flex gap-1.5" data-id="element-158">
                <motion.div className="w-3 h-3 rounded-full bg-[#004AC7]" animate={{
                y: [0, -6, 0],
                opacity: [0.6, 1, 0.6]
              }} transition={{
                duration: 1.6,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0
              }} data-id="element-159" />
                <motion.div className="w-3 h-3 rounded-full bg-[#007AFF]" animate={{
                y: [0, -6, 0],
                opacity: [0.6, 1, 0.6]
              }} transition={{
                duration: 1.6,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.2
              }} data-id="element-160" />
                <motion.div className="w-3 h-3 rounded-full bg-[#66A3FF]" animate={{
                y: [0, -6, 0],
                opacity: [0.6, 1, 0.6]
              }} transition={{
                duration: 1.6,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 0.4
              }} data-id="element-161" />
              </div>

              <form className="space-y-6 mt-4 md:mt-0" data-id="element-162">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-163">
                  <div data-id="element-164">
                    <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-165">
                      Voornaam <span className="text-red-500" data-id="element-166">*</span>
                    </label>
                    <input type="text" className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="Voornaam" data-id="element-167" />
                  </div>
                  <div data-id="element-168">
                    <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-169">
                      Achternaam <span className="text-red-500" data-id="element-170">*</span>
                    </label>
                    <input type="text" className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="Achternaam" data-id="element-171" />
                  </div>
                </div>

                <div data-id="element-172">
                  <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-173">
                    Email <span className="text-red-500" data-id="element-174">*</span>
                  </label>
                  <input type="email" className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="je.naam@voorbeeld.nl" data-id="element-175" />
                </div>

                <div data-id="element-176">
                  <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-177">
                    Je telefoonnummer <span className="text-red-500" data-id="element-178">*</span>
                  </label>
                  <input type="tel" className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="06 53689686" data-id="element-179" />
                </div>

                <div data-id="element-180">
                  <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-181">
                    Beschrijf wat we voor je kunnen doen{' '}
                    <span className="text-red-500" data-id="element-182">*</span>
                  </label>
                  <textarea rows={4} className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all resize-none" placeholder="Vertel wat we voor je kunnen betekenen..." data-id="element-183"></textarea>
                </div>

                <button type="button" className="w-full bg-[#007AFF] hover:bg-[#005FCC] text-white font-semibold py-4 rounded-xl transition-colors text-lg mt-4" data-id="element-184">
                  Verstuur
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};